import { endpoint } from 'services/endpoint';
import { http, httpQ4US } from 'services/http';
import { WEB_API_URL_Q4US } from 'services/constants/env';
import { TEmVatReportsApi } from './types';

export const emVatReports: TEmVatReportsApi = {
	getEmVatReportsList: (payload) =>
		http.post(endpoint.emVatReports.LIST, payload).then((response) => response.data),
	downloadEmVatReport: (url) => {
		// The report url already contains the full server path (e.g. `/internal/api/...`),
		// so it must be resolved against the Q4US server origin, not its baseURL.
		const fullUrl = url.startsWith('http')
			? url
			: `${new URL(WEB_API_URL_Q4US).origin}${url}`;
		return httpQ4US.get(fullUrl, { responseType: 'blob' }).then((response) => response.data);
	},
};
